import * as icons from "./icons";
import { messages as esARStoreComponents } from "./locales/es-AR/messages";
import { messages as ptBRStoreComponents } from "./locales/pt-BR/messages";
import { messages as esMXStoreComponents } from "./locales/es-MX/messages";
import { messages as esStoreComponents } from "./locales/es/messages";
export { RTCButton } from "./Button";
export { RTCContactCard } from "./ContactCard";
export { RTCFooter } from "./Footer";
export { RTCFAQs } from "./FAQs";
export { RTCMap } from "./Map";
export { RTCHeaderDesktop, RTCHeaderMobile } from "./Header";
export { RTCExtraInformation } from "./ExtraInformationBanner";
export { icons };
export { RTCFeaturedCard } from "./FeaturedCard";
export { RTCImageCarrousel } from "./ImageCarrousel";
export { RTCImage2Gallery } from "./ImageGallery2";
export { RTCImage3Gallery } from "./ImageGallery3";
export { RTCProductsCarousel } from "./ProductsCarousel";
export { RTCSocialNetworks } from "./SocialNetworks";
export { RTCText } from "./Text";
export { RTCTextImage } from "./TextImageElement";
export { RTCTitle } from "./Title";
export { useElementsContext, ElementsProvider } from "./elementsProvider";
export const LOCALES_MESSAGES = {
    "es-AR": esARStoreComponents,
    "pt-BR": ptBRStoreComponents,
    "es-MX": esMXStoreComponents,
    es: esStoreComponents,
};
//# sourceMappingURL=index.js.map